import React from 'react';

// Abstract SVG motifs used for insight cards — kept generic and design-system aligned.
export default function InsightMotif({ variant = 'rings', tone = '#22A94F' }) {
  const motifs = {
    rings: (
      <svg viewBox="0 0 220 160" className="w-full h-full">
        <circle cx="110" cy="80" r="56" fill="none" stroke={tone} strokeWidth="1.4" opacity="0.65" />
        <circle cx="110" cy="80" r="36" fill="none" stroke={tone} strokeWidth="1.4" />
        <circle cx="110" cy="80" r="16" fill={tone} opacity="0.85" />
        <path d="M 30 80 H 190" stroke="#1A1A1A" strokeOpacity="0.12" strokeDasharray="3 4" />
      </svg>
    ),
    grid: (
      <svg viewBox="0 0 220 160" className="w-full h-full">
        {Array.from({ length: 9 }).map((_, i) => (<line key={`v${i}`} x1={20 + i * 22} y1="20" x2={20 + i * 22} y2="140" stroke="#1A1A1A" strokeOpacity="0.08" />))}
        {Array.from({ length: 6 }).map((_, i) => (<line key={`h${i}`} x1="20" y1={20 + i * 24} x2="196" y2={20 + i * 24} stroke="#1A1A1A" strokeOpacity="0.08" />))}
        <circle cx="110" cy="80" r="10" fill={tone} />
        <circle cx="110" cy="80" r="22" fill="none" stroke={tone} strokeOpacity="0.5" />
      </svg>
    ),
    stack: (
      <svg viewBox="0 0 220 160" className="w-full h-full">
        <rect x="30"  y="36" width="160" height="22" rx="6" fill={tone} fillOpacity="0.16" stroke={tone} strokeOpacity="0.55" />
        <rect x="48"  y="68" width="124" height="22" rx="6" fill={tone} fillOpacity="0.28" stroke={tone} strokeOpacity="0.6" />
        <rect x="66"  y="100" width="88"  height="22" rx="6" fill={tone} fillOpacity="0.55" stroke={tone} />
      </svg>
    ),
    arcs: (
      <svg viewBox="0 0 220 160" className="w-full h-full">
        <path d="M 20 130 Q 100 20 200 80" stroke="#C4633F" strokeWidth="1.6" fill="none" />
        <path d="M 20 40 Q 100 140 200 20" stroke={tone} strokeWidth="1.6" fill="none" />
        <circle cx="110" cy="80" r="5" fill="#1A1A1A" />
      </svg>
    ),
    bars: (
      <svg viewBox="0 0 220 160" className="w-full h-full">
        {[30, 60, 90, 120, 150, 180].map((x, i) => (<rect key={x} x={x} y={40 + (i % 3) * 12} width="18" height={100 - (i % 3) * 12} fill={i % 2 ? tone : '#0F3D22'} opacity={0.9 - i * 0.08} />))}
      </svg>
    ),
  };
  return motifs[variant] || motifs.rings;
}
